import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';

function ExcelCard(props) {
    const {name, url, date} = props;

    const handleDownload = (event) => {
        event.preventDefault();
        window.open(url, '_blank');
    };

    return (
        <Card style={{boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)", border: "2px solid #ccc",borderRadius: "10px", margin:"4px"}}>
            <CardActionArea onClick={handleDownload}>
                <CardContent style={{ padding: '8px' }}>
                    <Typography 
                        variant="h5" 
                        component="div" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'space-between' 
                        }}>
                        <ArticleIcon style={{ marginRight: '8px', color: '#7EAA92' }} />
                        <Typography style={{marginRight: '8px'}} title={name}>
                            {name.slice(0,12)}
                        </Typography>
                    </Typography>
                    <Typography color="text.secondary" variant="body2">
                        {date}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

export default ExcelCard
